/** Alert subscriptions: who is told when a network or device goes offline — English, the source of the other languages */
const subscriptions = {
  "subscriptions.scope.SITE": "Network only",
  "subscriptions.scope.SITE_AND_DEVICES": "Network + devices",
  "subscriptions.scope.DEVICE": "Single device",
  "subscriptions.blurb.SITE": "Alerts when the site itself goes offline",
  "subscriptions.blurb.SITE_AND_DEVICES": "Also alerts for every device inside it",
  "subscriptions.blurb.DEVICE": "Alerts for one device only",
  "subscriptions.blurbDevices": { one: "Also alerts for every device inside it ({count} device)", other: "Also alerts for every device inside it ({count} devices)" },
  "subscriptions.channel.EMAIL": "Email",
  "subscriptions.unsubscribed": "Unsubscribed",
  "subscriptions.testSent": "Test sent by {channels}",
  "subscriptions.someFailed": "Some channels failed",
  "subscriptions.testFailed": "Test failed",
  "subscriptions.title": "Alert subscriptions",
  "subscriptions.subtitle": "Get told when a network or device goes offline",
  "subscriptions.subscribe": "Subscribe",
  "subscriptions.noPhone": "No phone number set",
  "subscriptions.ready": "ready",
  "subscriptions.unavailable": "unavailable",
  "subscriptions.empty": "No subscriptions yet. Subscribe to a network to be told when it drops.",
  "subscriptions.unknown": "Unknown",
  "subscriptions.paused": "paused",
  "subscriptions.alertsAfter": "Alerts after {duration} down",
  "subscriptions.reminderEvery": "Reminder every {duration}",
  "subscriptions.reminderEveryMax": "Reminder every {duration} (at most {max})",
  "subscriptions.oneMessage": "One message per outage",
  "subscriptions.recoveryOn": "Recovery notice on",
  "subscriptions.quiet": "Quiet {from}–{to}",
  "subscriptions.muted": "Muted:",
  "subscriptions.unmute": "Unmute",
  "subscriptions.unmuted": "{name} unmuted",
  "subscriptions.mutedName": "{name} muted",
  "subscriptions.muteDevice": "Mute a device in this network",
  "subscriptions.history": "Delivery history",
  "subscriptions.sendTest": "Send a test",
  "subscriptions.unsubscribe": "Unsubscribe",
  "subscriptions.unsubscribeConfirm": "Unsubscribe from these alerts?",
  "subscriptions.historyEmpty": "No alerts sent yet — nothing has gone offline since you subscribed.",
  "subscriptions.target": "Target",
  "subscriptions.downSince": "Down since",
  "subscriptions.messages": "Messages",
  "subscriptions.state": "State",
  "subscriptions.reminders": { one: "({count} reminder)", other: "({count} reminders)" },
  "subscriptions.state.PENDING": "waiting",
  "subscriptions.state.NOTIFIED": "sent",
  "subscriptions.state.RECOVERED": "recovered",
  "subscriptions.newTitle": "Subscribe to alerts",
  "subscriptions.network": "Network *",
  "subscriptions.chooseNetwork": "Choose a network…",
  "subscriptions.watchWhat": "What do you want to watch?",
  "subscriptions.device": "Device *",
  "subscriptions.chooseDevice": "Choose a device…",
  "subscriptions.sendVia": "Send alerts by *",
  "subscriptions.rcsNote": "RCS arrives in the phone's own messages app. It does not reach iPhones in the Netherlands yet.",
  "subscriptions.rcsNoteTwilio": "RCS arrives in the phone's own messages app. It does not reach iPhones in the Netherlands yet; with an SMS number in the Twilio service they get an SMS.",
  "subscriptions.howOften": "How often",
  "subscriptions.wait": "Wait before alerting",
  "subscriptions.waitHint": "minutes — ignores brief blips and reboots",
  "subscriptions.remind": "Remind me while it stays down",
  "subscriptions.remindHint": "Off by default — you get exactly one message per outage.",
  "subscriptions.every": "every",
  "subscriptions.remindEvery": "Remind every",
  "subscriptions.stopAfter": "stop after",
  "subscriptions.stopAfterLabel": "Stop after this many reminders",
  "subscriptions.remindersWord": "reminders",
  "subscriptions.recovers": "Tell me when it recovers",
  "subscriptions.recoversHint": "One message when it comes back online",
  "subscriptions.quietHours": "Quiet hours",
  "subscriptions.quietHint": "Messages are held until the window ends",
  "subscriptions.quietStart": "Start of the quiet hours",
  "subscriptions.quietEnd": "End of the quiet hours",
  "subscriptions.to": "to",
  "subscriptions.subscribed": "Subscribed",
  "subscriptions.subscribeFailed": "Could not subscribe",
  "subscriptions.devicesIn": "Devices in {name}",
  "subscriptions.muteInfo": "Mute a device to stop its alerts while keeping the rest of the network subscribed.",
  "subscriptions.noDevices": "No devices found on this network",
  "subscriptions.unmuteTitle": "Unmute — resume the alerts",
  "subscriptions.muteTitle": "Mute — stop the alerts for this device",
  "subscriptions.mute": "Mute",
  "subscriptions.done": "Done",
  "subscriptions.notChanged": "Not changed",
  "subscriptions.channel.PUSH": "Push (phone app)",
  "subscriptions.pushPhones": "Phones with push: {n}",
  "subscriptions.pushFirst.first": {"one": "Push goes first. {channel} follows after {count} minute if you haven't opened the site.", "other": "Push goes first. {channel} follows after {count} minutes if you haven't opened the site."},
  "subscriptions.pushFirst.atOnce": "{channel} goes at once: none of your phones has push allowed (Profile → Phone app).",
  "subscriptions.pushFirst.automatic": "Push is sent first anyway for your WhatsApp and RCS alerts.",
}

export default subscriptions
